/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:1bc65925-45a6-46db-9482-82d539c0eebc",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_d5Cf4v6fT",
    "aws_user_pools_web_client_id": "4ppf1o02m9qrk5eei9qakpd4e",
    "oauth": {
        "domain": "rvpanel-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "https://firma.realvirtual.com.mx/login/callback/",
        "redirectSignOut": "https://firma.realvirtual.com.mx/logout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://avxcakkzaraqfh3oleacetxuka.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "firmadocs30122-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
